import type { ViewerPluginCreator } from 'wix-rich-content-common';

import { DEFAULT_RICOS_COMPONENT_DATA } from './defaults';
import type { PollPluginViewerConfig } from './types';
import { POLL_TYPE } from './types';
export { POLL_TYPE, PollPluginViewerConfig };
import { nodeViewRenderers } from './viewer/nodeViewRenderers-loadable';

export const pluginPoll: ViewerPluginCreator<PollPluginViewerConfig> = config => {
  return {
    config: { ...DEFAULT_RICOS_COMPONENT_DATA.containerData, ...config },
    type: POLL_TYPE,
    nodeViewRenderers,
  };
};
